import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-movie-2-line text-xl text-primary-500"></i>
                </div>
                <span className="text-lg font-heading font-bold text-foreground-100">
                  51<span className="text-primary-500">影视</span>
                </span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed">
                51影视网提供电视剧全集免费在线观看，最新热播剧免费看，高清不卡顿，畅享追剧体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <Link to="/category/drama" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">电视剧</Link>
                <Link to="/category/movie" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">电影</Link>
                <Link to="/category/anime" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">动漫</Link>
                <Link to="/category/variety" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">综艺</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">热门推荐</h4>
              <div className="flex flex-col gap-2">
                <Link to="/article/4" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">暑期档观剧指南</Link>
                <Link to="/article/1" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">2026年最值得期待的十部剧</Link>
                <Link to="/article/3" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">国漫崛起深度解析</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">用户协议</a>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">免责声明</a>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2026 51影视 51yingshi.com 版权所有 | 本站内容仅供学习交流，请于下载后24小时内删除
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">网站地图</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">RSS订阅</a>
          </div>
        </div>
      </div>
    </footer>
  );
}